export default function getS3ImageUrl(path: string = "") {
  const baseUrl =
    process.env.REACT_APP_CDN_URL ??
    window["REACT_APP_CDN_URL"] ??
    "https://staging-cdn.amaseyewear.com";

  return `${baseUrl}/${path}`;
}
